<template>
  <div>
    <ts-page-title
      :title="$t('employeeProfile.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('employeeProfile.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="tw-flex tw-items-center tw-justify-between">
        <a-button
          type="primary"
          @click="$router.push({ name: 'employee-profile-create' })"
        >
          {{ $t("addNew") }}
        </a-button>
        <div class="tw-justify-end tw-space-x-2">
          <a-input
            v-model="search"
            v-tooltip="$t('employeeProfile.search')"
            :placeholder="$t('search')"
            style="width: 250px"
            class="inline-block"
          />
          <a-button v-tooltip="$t('filter')" @click.prevent="visible = true">
            <i class="fa fa-filter"></i>
          </a-button>
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="tw-whitespace-nowrap">
              <img
                class="tw-rounded tw-h-8 tw-w-7"
                v-lazy="{
                  src: photo(record),
                  error:
                    record.sex == 'Male'
                      ? require('@/assets/staff-default-man.png')
                      : require('@/assets/staff-default-women.png'),
                  loading: require('@/assets/Rolling-1s-200px.svg'),
                  preLoad: 1.3,
                  attempt: 1,
                }"
              />
            </td>
            <td class="tw-text-center tw-whitespace-nowrap">
              {{ record.branch.prefix_code }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.card_id }}
            </td>
            <td class="tw-whitespace-nowrap">{{ record.employee_name_kh }}</td>
            <td class="tw-whitespace-nowrap">{{ record.employee_name_en }}</td>
            <td class="tw-text-center tw-whitespace-nowrap">
              {{ record.sex }}
            </td>
            <td class="tw-text-center tw-whitespace-nowrap">
              {{ record.status.status }}
            </td>
            <td class="tw-whitespace-nowrap">{{ record.hire_date }}</td>
            <td class="tw-whitespace-nowrap">{{ record.phone }}</td>
            <!-- <td>{{ record.shift ? record.shift.shift_name : null }}</td> -->
            <!-- <td>
            {{
              record.payroll_cycle_date
                ? record.payroll_cycle_date.pc_date_name
                : null
            }}
          </td> -->
            <td class="text-center tw-space-x-3">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
        <a-drawer
          :title="$t('filter')"
          :closable="false"
          :visible="visible"
          :zIndex="1020"
          @close="() => (visible = false)"
          width="300px"
        >
          <div class="mb-3">
            <label class="form-col-label control-label">{{
              $t("testingCenter")
            }}</label>
            <ts-branch-filter @filter="(value) => (branch_id = value)" />
          </div>
        </a-drawer>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";
export default {
  name: "employeeProfileIndex",
  data() {
    return {
      visible: false,
      file_src: require("../../../assets/staff-default-man.png"),
      loading: false,
      showForm: false,
      branch_id: [],
    };
  },
  computed: {
    ...mapState("humanResource/employeeProfile", ["resources", "pagination"]),
    search: {
      get() {
        return this.$store.state.humanResource.employeeProfile.search;
      },
      set(newValue) {
        this.$store.commit(
          "humanResource/employeeProfile/SET_SEARCH",
          newValue
        );
        this.$store.commit("humanResource/employeeProfile/RESET_CURRENT_PAGE");
      },
    },
    columns() {
      return [
        {
          name: this.$t("employeeProfile.photo"),
          style: "width:50px;white-space: nowrap;",
        },
        {
          name: this.$t("employeeProfile.testingCenter"),
          style: "text-align:center;width:150px;white-space: nowrap;",
        },
        {
          name: this.$t("employeeProfile.cardNumber"),
          style: "white-space: nowrap;width:100px;",
        },
        {
          name: this.$t("employeeProfile.nameKh"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("employeeProfile.nameEn"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("employeeProfile.sex"),
          style: "text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("employeeProfile.status"),
          style: "text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("employeeProfile.hiredDate"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("employeeProfile.phone"),
          style: "white-space: nowrap;",
        },
        // { name: this.$t("employeeProfile.shift") },
        // { name: this.$t("employeeProfile.payrollCycleDate") },
        {
          name: this.$t("actions"),
          style: "text-align:center; width: 1px;white-space: nowrap;",
        },
      ];
    },
  },
  methods: {
    photo(record) {
      if (record.photo) {
        return record.photo;
      }

      return record.sex == "Male"
        ? require("@/assets/staff-default-man.png")
        : require("@/assets/staff-default-women.png");
    },
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("humanResource/employeeProfile/fetch", {
          ...attributes,
          branch_id: this.branch_id,
        })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    addNew() {
      this.showForm = true;
    },
    edit(record) {
      this.$store.commit("humanResource/employeeProfile/SET_EDIT_DATA", record);
      this.$router.push({
        name: "employee-profile-edit",
        params: { id: record.employee_id },
      });
    },
    clearEdit() {
      this.$store.commit("humanResource/employeeProfile/SET_EDIT_DATA", {});
      this.showForm = false;
      this.fetchData();
    },
    deleteRecord(record) {
      record._deleting = true;
      this.$store
        .dispatch("humanResource/employeeProfile/destroy", record.employee_id)
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          record._deleting = false;
        });
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData();
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value });
    }, 500),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("humanResource/employeeProfile/RESET_STATE");
    next();
  },
};
</script>

<style lang="scss" scoped>
</style>